<pt-editor-view
  class="flex-1"
  [extensions]="extensions"
  [content]="content$ | async"
/>
